var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupDisableLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73166 5.96203C9.08122 6.12918 9.39183 6.36778 9.64344 6.66242C9.89505 6.95706 10.0821 7.30119 10.1924 7.67259C10.3028 8.04399 10.334 8.4344 10.2841 8.81862C10.2342 9.20284 10.1043 9.57232 9.9027 9.90321M3.89185 8.19137L2.81128 9.2725C2.29188 9.79179 2.00006 10.4961 2 11.2306C1.99994 11.965 2.29166 12.6694 2.81097 13.1888C3.33029 13.7081 4.03466 13.9999 4.76914 14C5.50362 14.0001 6.20804 13.7084 6.72743 13.1891L8.6529 11.2637M12.1075 7.80863L13.1887 6.7275C13.7081 6.20821 13.9999 5.50387 14 4.76943C14.0001 4.03499 13.7083 3.33061 13.189 2.81124C12.6697 2.29187 11.9653 2.00006 11.2309 2C10.4964 1.99994 9.79196 2.29164 9.27257 2.81093L6.50344 5.57991C6.34468 5.7399 6.20869 5.9128 6.09669 6.09679M7.26772 10.038C6.98403 9.90223 6.72557 9.71911 6.50344 9.49648C6.21077 9.2046 5.98743 8.85068 5.84993 8.46088M13.5382 13.5386L9.90331 9.90383L6.09607 6.09617M2.46114 2.46081L6.09607 6.0974",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupDisableLink);
export default __webpack_public_path__ + "static/media/group_disable_link.c30ae134f9e496aea9bc39f0a7620cdd.svg";
export { ForwardRef as ReactComponent };